import httpClient, { directAPI } from "./httpClient";
import { createRequestWithFallback } from "./httpClient";

// Servicios específicos por dominio
export const accountsService = {
  getAccounts: createRequestWithFallback(
    "/functions/account-information-summary"
  ),
  getSingleAccount: (accountId) =>
    httpClient.get(`/functions/single-account-information?account-id=${accountId}`),
  updateAccount: (accountId, accountData) =>
    httpClient.post(`/functions/single-account-information?account-id=${accountId}`, accountData),
  getActivityLog: (accountId) =>
    httpClient.get(`/functions/single-account-information/activity-log?account-id=${accountId}`),
  getOpcos: createRequestWithFallback(
    "/functions/list-management-information/opco"
  ),
  getTypes: createRequestWithFallback(
    "/functions/list-management-information/types"
  ),
  getDomains: createRequestWithFallback(
    "/functions/list-management-information/domain"
  ),
  getOrganizations: createRequestWithFallback(
    "/functions/list-management-information/organizations"
  ),
  getContacts: createRequestWithFallback(
    "/functions/list-management-information/contacts"
  ),
  createContact: (contactData) =>
    httpClient.post("/functions/list-management-information/contacts", contactData),
  getCostCenters: createRequestWithFallback(
    "/functions/list-management-information/cost-center"
  ),
  createCostCenter: (costCenterData) =>
    httpClient.post("/functions/list-management-information/cost-center", costCenterData),
  getGroups: createRequestWithFallback(
    "/functions/list-management-information/groups"
  ),
  getPermissionSetsByAccount: (accountId, awsOrganization) =>
    httpClient.get(`/functions/list-management-information/permissions-set-by-account?account-id=${accountId}&aws-organization=${awsOrganization}`),
  getPermissionSetsByUser: (assignedName) =>
    httpClient.get(`/functions/list-management-information/permissions-set-by-user?assigned-name=${encodeURIComponent(assignedName)}`),
  getCloudProviders: createRequestWithFallback(
    "/functions/list-management-information/cloud-provider"
  ),
  createAccount: (accountData) =>
    httpClient.post("/functions/create-account/aws", accountData),
  getFromDatabase: (tableName) => {
    const params = new URLSearchParams();
    params.append("aws-table-name", tableName);
    return createRequestWithFallback(`/functions/list-from-db/aws?${params.toString()}`)();
  },
};

export const wizService = {
  getWizReport: (accountId, email, returnFile) => {
    const params = new URLSearchParams();
    params.append("account-id", accountId);
    if (email) params.append("email", email);
    if (returnFile !== undefined) params.append("return-file", returnFile);

    return httpClient
      .post(`/functions/wiz?${params.toString()}`, {})
      .catch((error) => {
        return directAPI.post(`/functions/wiz?${params.toString()}`, {});
      });
  },
};

export const awsReportsService = {
  getReportsAwsS3: createRequestWithFallback("/functions/reports/aws-s3"),
  getReportsAwsEC2: createRequestWithFallback(
    "/functions/reports/aws-ec2-instances"
  ),
  getReportsAwsIamUsers: createRequestWithFallback(
    "/functions/reports/aws-iam-users"
  ),
  getReportsAwsADUsers: createRequestWithFallback(
    "/functions/reports/aws-ad-users"
  ),
  getReportsAwsADGroups: createRequestWithFallback(
    "/functions/reports/aws-ad-groups"
  ),
  getReportsAwsRDS: createRequestWithFallback("/functions/reports/aws-rds"),
  getReportsAwsEFS: createRequestWithFallback("/functions/reports/aws-efs"),
  getReportsAwsAccounts: createRequestWithFallback(
    "/functions/reports/aws-accounts"
  ),
};

// API unificada para compatibilidad (deprecated - usar servicios específicos)
export const accountsAPI = {
  ...accountsService,
  ...wizService,
  ...awsReportsService,
};

export { httpClient as api, directAPI };

export default httpClient;
